import { render, staticRenderFns } from "./CreateTaxEventModal.vue?vue&type=template&id=304c1848&"
import script from "./CreateTaxEventModal.vue?vue&type=script&lang=ts&"
export * from "./CreateTaxEventModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports